<div class="row" [attr.data-tone]="vm?.tone">
  <span class="row__icon" aria-hidden="true">
    <mat-icon class="row__glyph" fontSet="material-icons-round">{{ vm?.icon }}</mat-icon>
  </span>
  <div class="row__content">
    <p class="row__headline">{{ vm?.headline }}</p>
    <p class="row__subline">{{ vm?.subline }}</p>
  </div>
  <a mat-button class="row__cta" [routerLink]="vm?.route" [queryParams]="vm?.queryParams">{{ vm?.ctaLabel }}</a>
</div>
